import React from 'react';
import { object, node } from 'prop-types';
import { MenuFiltersProvider } from 'common/providers/menuFiltersProvider';
import { CaloriesProvider } from 'common/providers/caloriesProvider';
import { WalletProvider } from 'payment/providers/walletProvider';
import OfflineProvider from 'common/providers/offlineProvider';
import StripeProvider from 'payment/providers/stripeProvider';
import ConfigProvider from 'common/providers/configProvider';
import BasketProvider from 'menus/providers/BasketProvider';
import OatNavigation from 'common/providers/oatNavigation';
import PdqProvider from 'common/providers/PdqProvider';
import OATProvider from 'common/providers/oatProvider';
import ContentProvider from 'content/content-provider';
import Analytics from 'common/components/Analytics';
import { CookiesProvider } from 'react-cookie';
import fromEntries from 'object.fromentries';
import ErrorBoundary from './error-boundary';

if (!Object.fromEntries) {
  Object.fromEntries = fromEntries;
}
const WrapPageElement = ({ element, props }) => (
  <ErrorBoundary>
    <ConfigProvider {...props}>
      <PdqProvider>
        <ContentProvider {...props}>
          <CookiesProvider>
            <OfflineProvider>
              <StripeProvider>
                <WalletProvider>
                  {/* Any providers inside OAT Provider will get unmounted during page changes when the
                        splash screen is shown */}
                  <OATProvider {...props}>
                    <OatNavigation>
                      <BasketProvider>
                        <Analytics />
                        <MenuFiltersProvider>
                          <CaloriesProvider>{element}</CaloriesProvider>
                        </MenuFiltersProvider>
                      </BasketProvider>
                    </OatNavigation>
                  </OATProvider>
                </WalletProvider>
              </StripeProvider>
            </OfflineProvider>
          </CookiesProvider>
        </ContentProvider>
      </PdqProvider>
    </ConfigProvider>
  </ErrorBoundary>
);

WrapPageElement.propTypes = {
  element: node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  props: object.isRequired,
};

export default WrapPageElement;
